import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Modal,
    Avatar,
    Button,
    Space,
    Table,
    Tag,
    Typography,
    Tooltip,
    Input,
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { context } from "../../context/context";
import "font-awesome/css/font-awesome.min.css";

// api
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { toast } from "react-toastify";

const Tables = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "tag"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    const {
        setIsModalOpen,
        shahr,
        setShahr,
        ostan,
        setOstan,
        shahrestan,
        setShahrestan,
        provinces,
        setProvinces,
        forceUpdate,
        setOstanIcon,
        setOstanColor,
        setOstanName,
        setOstanId,
        setIsEditShow,
        country,
        setCountry,
        setParentOstanId,
        setCountryId,
        countryId,
        parentOstanId,
        setForceUpdate,
        setShahrestanName,
        setShahrestanIcon,
        setShahrestanColor,
        city,
        setCity,
        setCityId,
        cityId,
        setCityColor,
        setCityIcon,
        setCityName,
        setCityTag,
        setVillage,
        village,
        setShahrestanId,
    } = useContext(context);
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Geopolitics/`)
            .then((res) => {
                setLoading(false);
                setProvinces(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);

    const deleteModal = () => {
        setDeleteIsModalOpen(true);
    };

    const handleOk = () => {
        setDeleteIsModalOpen(false);
        if (shahrestan) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/deleteCountry`, {
                provinceId: parentOstanId,
                countryId: countryId,
            })
                .then(() => {
                    setOstan(true);
                    setShahrestan(false);
                    setForceUpdate(5);
                    toast.success("شهرستان با موفقیت پاک شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                })
                .catch((err) => {
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    console.log(err);
                });
        } else if (shahr && isCity) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/deleteCity`, {
                provinceId: parentOstanId,
                countryId: countryId,
                cityId: cityId,
            })
                .then((res) => {
                    toast.success(" شهر با موفقیت پاک شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    setOstan(true);
                    setShahrestan(false);
                    setShahr(false);
                    setForceUpdate(5);
                    console.log(res.data.success);
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        } else if (shahr && !isCity) {
            http.post(`${config.parkopoloApi}/api/Geopolitics/deleteVillage`, {
                provinceId: parentOstanId,
                countryId: countryId,
                villageId: cityId,
            })
                .then((res) => {
                    toast.success(" روستا با موفقیت پاک شد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                    setOstan(true);
                    setShahrestan(false);
                    setShahr(false);
                    setForceUpdate(5);
                    console.log(res.data.success);
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(" خطایی رخ داد !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        progress: undefined,
                        theme: "colored",
                        style: { fontFamily: "Vazir" },
                    });
                });
        }
    };

    const handleCancel = () => {
        setDeleteIsModalOpen(false);
    };
    const [loading, setLoading] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleEdit = (record) => {
        provinces.map((p) => {
            if (p._id === record._id) {
                setOstanName(p.province);
                setOstanColor(p.color);
                setOstanIcon(p.icon);
                setOstanId(p._id);
            }
        });
        showModal();
        setIsEditShow(true);
    };
    const handleEditShahrestan = (record) => {
        provinces.map((p) => {
            if (p._id === parentOstanId) {
                p.county.map((c) => {
                    if (c._id === record._id) {
                        setShahrestanName(c.name);
                        setShahrestanColor(c.color);
                        setShahrestanIcon(c.icon);
                    }
                });
            }
        });
        showModal();
        setIsEditShow(true);
    };
    const handleEditCity = (record) => {
        setCityName(record.name);
        setCityIcon(record.icon);
        setCityColor(record.color);
        setCityTag(record.tag);
        showModal();
        setIsEditShow(true);
    };
    const handleTableChange = () => {
        if (ostan) {
            setOstan(false);
            setShahrestan(true);
            setForceUpdate(15);
        } else if (shahrestan && !ostan) {
            setShahrestan(false);
            setShahr(true);
            setForceUpdate(15);
        }
    };

    const handleRowClick = (record) => {
        if (ostan && record.county) {
            setCountry(record.county);
            setParentOstanId(record._id);
        }
        if (shahrestan) {
            const itemId = record._id;
            setCountryId(itemId);
            setCity(record.city);
            setVillage(record.village);
            setShahrestanId(record._id);
        }
        if (shahr) {
            setCityId(record._id);
        }
    };
    const [isCity, setIsCity] = useState(true);
    const handleDelete = (record) => {
        setIsCity(city.find((c) => c._id === record._id));
        deleteModal();
    };
    const handleCountryClick = (e, cities, villages, countryId, provinceId) => {
        e.stopPropagation();
        setCountryId(countryId);
        setParentOstanId(provinceId);
        setOstan(false);
        setShahrestan(false);
        setShahr(true);
        setVillage(villages);
        setCity(cities);
    };
    const ostanColumns = [
        {
            title: "اسم استان",
            dataIndex: "province",
            key: "_id",
            render: (text) => (
                <Tooltip title={`نمایش شهرستان های ${text}`}>
                    <Typography.Link onClick={handleTableChange}>
                        {text}
                    </Typography.Link>
                </Tooltip>
            ),
        },
        {
            title: "آیکون",
            dataIndex: "icon",
            key: "icon",
            render: (icon) => {
                return icon ? (
                    <i
                        className={`fa ${icon
                            .split(/(?=[A-Z])/)
                            .map((word) => word.toLowerCase())
                            .join("-")}`}
                        style={{ fontSize: "30px" }}
                    />
                ) : null;
            },
        },
        {
            title: "رنگ",
            dataIndex: "color",
            key: "color",

            render: (color) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: `${color}`,
                            width: "40px",
                            height: "40px",
                        }}
                    ></div>
                </div>
            ),
        },
        {
            title: "شهرستان ها",
            dataIndex: "county",
            key: "county",

            render: (county) => (
                <div style={{ display: "flex", gap: "8px" }}>
                    {county.map((c) => {
                        return (
                            <Tooltip
                                key={c._id}
                                title={`نمایش شهر و روستاهای ${c.name}`}
                            >
                                <Typography.Link
                                    onClick={(e) =>
                                        handleCountryClick(
                                            e,
                                            c.city,
                                            c.village,
                                            c._id,
                                            provinces.find((p) =>
                                                p.county.includes(c)
                                            )._id
                                        )
                                    }
                                >
                                    {c.name}
                                </Typography.Link>
                            </Tooltip>
                        );
                    })}
                </div>
            ),
        },
        {
            title: "",
            dataIndex: "button",
            key: "button",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Tooltip title="ویرایش استان">
                            <Button
                                onClick={() => handleEdit(record)}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];
    const shahrestanColumns = [
        {
            title: "اسم شهرستان",
            dataIndex: "name",
            key: "_id",
            render: (text) => (
                <Tooltip title={`نمایش شهر و روستاهای ${text}`}>
                    <Typography.Link onClick={handleTableChange}>
                        {text}
                    </Typography.Link>
                </Tooltip>
            ),
        },
        {
            title: "آیکون",
            dataIndex: "icon",
            key: "icon",
            render: (icon) => {
                return icon ? (
                    <i
                        className={`fa ${icon
                            .split(/(?=[A-Z])/)
                            .map((word) => word.toLowerCase())
                            .join("-")}`}
                        style={{ fontSize: "30px" }}
                    />
                ) : null;
            },
        },
        {
            title: "رنگ",
            dataIndex: "color",
            key: "color",

            render: (color) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: `${color}`,
                            width: "40px",
                            height: "40px",
                        }}
                    ></div>
                </div>
            ),
        },

        {
            title: "عکس کاور",
            dataIndex: "coverPic",
            key: "coverPic",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={`${coverPic?.address}`} />}
                />
            ),
        },
        {
            title: "",
            dataIndex: "button",
            key: "button",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={(record) => {
                                return handleDelete(record);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش شهرستان">
                            <Button
                                onClick={() => handleEditShahrestan(record)}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];
    const shahrColumns = [
        {
            title: "شهر یا روستا",
            dataIndex: "isCity",
            key: "isCity",
            render: (text, record) => (
                <Typography onClick={handleTableChange}>
                    {city.find((c) => c._id === record._id) ? "شهر" : "روستا"}
                </Typography>
            ),
        },
        {
            title: "عنوان",
            dataIndex: "name",
            key: "_id",
            ...getColumnSearchProps("name"),
            render: (textو, { name }) => (
                <Typography.Link onClick={handleTableChange}>
                    {name}
                </Typography.Link>
            ),
        },
        {
            title: "آیکون",
            dataIndex: "icon",
            key: "icon",
            render: (icon, { color }) => {
                return icon ? (
                    <i
                        className={`fa ${icon
                            .split(/(?=[A-Z])/)
                            .map((word) => word.toLowerCase())
                            .join("-")}`}
                        style={{ fontSize: "30px" }}
                    />
                ) : null;
            },
        },
        {
            title: "تگ(ها)",
            key: "tag",
            dataIndex: "tag",
            ...getColumnSearchProps("tag"),

            render: (_, { tag }) => (
                <>
                    {tag.map((t) => {
                        return <Tag key={t}>{t.toUpperCase()}</Tag>;
                    })}
                </>
            ),
        },
        {
            title: "عکس کاور",
            dataIndex: "coverPic",
            key: "coverPic",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={`${coverPic?.address}`} />}
                />
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            width: "10%",
            key: "button",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                return handleDelete(record);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش شهر/روستا">
                            <Button
                                onClick={() => {
                                    return handleEditCity(record);
                                }}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];

    return (
        <>
            <Table
                size="small"
                loading={loading}
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                }}
                bordered
                columns={
                    ostan
                        ? ostanColumns
                        : shahrestan
                        ? shahrestanColumns
                        : shahr
                        ? shahrColumns
                        : null
                }
                dataSource={
                    ostan
                        ? provinces
                        : shahrestan
                        ? country
                        : shahr
                        ? city.concat(village)
                        : null
                }
                style={{ marginTop: "15px" }}
                scroll={{ x: true }}
                onRow={(record) => {
                    return {
                        onClick: () => handleRowClick(record),
                    };
                }}
            />
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default Tables;
